import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Container, CssBaseline, Typography } from "@material-ui/core";
import Lottie from "react-lottie";

import { i18n } from "../../translate/i18n";
import ForgotPasswordLottie from "../../assets/lottie/forgotPassword.json";

import iconLight from "../../assets/miscPng/icon.png";
import iconDark from "../../assets/miscPng/icon-dark.png";

import DefaultValuesUtils from "../../utils/classes/DefaultValuesUtils";
import LottieUtils from "../../utils/classes/LottieUtils";

const useStyles = makeStyles((theme) => ({
  //  ****************
  //  ** Containers **
  //  ****************
  expiredPasswordResetContainer: {
    width: "100vw",
    height: "90vh",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    marginTop: "5vh",
    userSelect: "none",
    name: theme.name,
    color: theme.palette.lottie.plainBackground,
  },

  imgContainer: {
    backgroundColor: theme.palette.lottie.plainBackground,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "10px 0px 0px 10px",
    [theme.breakpoints.down("sm")]: { display: "none", },
  },

  expiredPasswordResetForm: {
    backgroundColor: theme.palette.lottie.secondaryPlainBackground,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "0px 10px 10px 0px",
  },

  //  ********************
  //  ** Form Container **
  //  ********************
  avatar: {
    margin: theme.spacing(0),
    width: "100px",
    height: "auto",
  },

  floatingButton: {
    margin: theme.spacing(3, 0, 2),
    transition: "transform 0.30s",
    "&:hover": { transform: "translateY(-5px)", },
  },

  secondaryButton: { color: theme.palette.lottie.plainBackground, },
}));

const ExpiredPasswordReset = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const history = useHistory();

  const currentIcon = localStorage.getItem("theme") ? iconDark : iconLight;

  

  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => { document.title = "BestZap"; }, []);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleBack = (path) => { history.push(path); };



  //  ************
  //  ** Return **
  //  ************
  return (
    <Container className={classes.expiredPasswordResetContainer} component="main">
      <CssBaseline />

      <div className={classes.imgContainer}>
        <Lottie
          options={{ ...LottieUtils.ANIMATION_PROPERTIES, animationData: ForgotPasswordLottie }}
          isClickToPauseDisabled={true}
          style={{ width: "80.00%", height: "80.00%", }}
        />
      </div>

      <div className={classes.expiredPasswordResetForm}>
        <img className={classes.avatar} src={currentIcon} alt="BestZap Logo" />

        <Typography component="h1" variant="h3">
          {i18n.t("passwordReset.title")}
        </Typography>

        <Typography component="h2" variant="h6">
          <br />
          {i18n.t("expiredPasswordReset.subtitle")}
          <br /><br />
        </Typography>

        <Button
          type="button"
          style={{ width: "80%" }}
          variant="contained"
          color="primary"
          className={`${classes.floatingButton} ${classes.secondaryButton}`}
          onClick={() => handleBack(DefaultValuesUtils.ROUTES[102])}
        >
          {i18n.t("expiredPasswordReset.buttons.backLogin")}
        </Button>

        <Button
          type="button"
          style={{ width: "80%" }}
          variant="outlined"
          color="primary"
          className={`${classes.floatingButton} ${classes.secondaryButton}`}
          onClick={() => handleBack(DefaultValuesUtils.ROUTES[103])}
        >
          {i18n.t("expiredPasswordReset.buttons.backPasswordReset")}
        </Button>
      </div>
    </Container>
  );
};

export default ExpiredPasswordReset;
